import {
    Button,
    Label,
    Table, TableBody,
    TableCell,
    TableCellActions,
    TableCellLayout,
    TableHeader,
    TableHeaderCell,
    TableRow,
    makeStyles, shorthands
} from "@fluentui/react-components";
import { DeleteFilled, DeleteRegular, EditFilled, EditRegular, bundleIcon } from "@fluentui/react-icons";
import axios from "axios";
import { collection, getDocs, query, where } from "firebase/firestore";
import debounce from 'lodash/debounce';
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import CustomSearchInput from "./components/CustomSearchInput";
import DeleteEventDialog from "./components/DeleteEventDialog";
import VehicleForm from "./components/Forms/VehicleForm";
import ImageDialog from "./components/ImageDialog";
import Layout from "./components/Layout";
import { Base_Url, auth, db, trackException } from "./services/firebase";
import GroupDataService from "./services/groupDataService";
import rentalLocationDataService from "./services/rentalLocationDataService";
import UserDataService from "./services/userDataService";
import VehicleDataService from "./services/vehicleDataService";
import { PlusSVG } from "./static/svgs";
import useBreakpoint from "./hooks/useBreakpoint";
import "./components/Forms/FormStyle.css";
const EditIcon = bundleIcon(EditFilled, EditRegular);
const DeleteIcon = bundleIcon(DeleteFilled, DeleteRegular);

const useStyles = makeStyles({
    root: {
        ...shorthands.overflow("hidden"),
        display: "flex",
        height: "480px",
        backgroundColor: "#fff"
    },

    content: {
        ...shorthands.flex(1),
        ...shorthands.padding("16px"),
        display: "block",
        ...shorthands.gridArea("main")
    },

    breakFlex: {
        flexBasis: "100%",
        textAlign: "left"
    }
});

const columns = [
    { columnKey: "year", label: "Year" },
    { columnKey: "make", label: "Make" },
    { columnKey: "model", label: "Model" },
    { columnKey: "member", label: "Member" },
    { columnKey: "pricePerDay", label: "Cost per Day" },
    { columnKey: "isPartOfWarehouseRentalFleet", label: "Rental Fleet" },
    { columnKey: "isPartOfWarehouseSalesFleet", label: "Sales Fleet" },
    { columnKey: "images", label: "Images" }
];

let fobPageNum = 1;
function Vehicles() {
    const styles = useStyles();
    const [user, loading, error] = useAuthState(auth);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [selectedVehicle, setSelectedVehicle] = useState();
    const [allvehicles, setAllVehicles] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredVehicles, setFilteredVehicles] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [alllocations, setAllLocations] = useState([]);
    const [allgroups, setAllGroup] = useState([]);
    const [fobKeys, setfobKeys] = useState([]);
    const [hasMoreKeys, sethasMoreKeys] = useState(true);
    const [open, setOpen] = React.useState(false);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = React.useState(false);
    const navigate = useNavigate();
    const breakpoint = useBreakpoint();
    const isMobile = breakpoint === 'mobile';
    const openForm = (selectedItem) => {
        setIsFormOpen(true);
        setSelectedVehicle(selectedItem);
    }

    const openFormNew = () => {
        setIsFormOpen(true);
        let r = (Math.random() + 1).toString(36).substring(7);
        setSelectedVehicle(r);
    }

    const fetchUserNameAndVehicles = async () => {
        try {
            if (!!user) {
                const userquery = query(collection(db, "Users"), where("email", "==", user?.email));
                const userdoc = await getDocs(userquery);
                if (userdoc.docs.length > 0) {
                    const vehiclesQuery = await VehicleDataService.getAllVehicle();
                    let vehicleArr = vehiclesQuery.docs.map((doc) => ({ ...doc.data(), id: doc.id }))

                    setAllVehicles([...vehicleArr]);
                    setFilteredVehicles(vehicleArr)

                    //setAllVehicles(vehiclesQuery.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
                    const usersQuery = await UserDataService.getAllUser();
                    let allUserArr = usersQuery.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
                    allUserArr.sort((a, b) => {
                        const lastNameA = a.lastName || ''; // If lastName is null or undefined, treat it as empty string
                        const lastNameB = b.lastName || ''; // If lastName is null or undefined, treat it as empty string
                        return lastNameA.localeCompare(lastNameB); // Compare the last names alphabetically
                    });
                    setAllUsers(allUserArr);

                    const groupsQuery = await GroupDataService.getAllGroup();
                    let sortedGroups = groupsQuery.docs
                        .map((doc) => ({ ...doc.data(), id: doc.id }))
                        .sort((a, b) => a.title.localeCompare(b.title)); // Sort by title

                    sortedGroups.splice(0, 0, { "title": "N/A", "id": "NA" });
                    setAllGroup(sortedGroups);
                } else {
                    console.log('no access');
                }
            }
        } catch (err) {
            trackException(JSON.stringify(err))
            console.error(err);
            alert("An error occured while fetching user data");
        }
    };

    const fetchAllLocations = async () => {
        try {
            const vehiclesQuery = await rentalLocationDataService.getAllRentalLocation();
            setAllLocations(vehiclesQuery.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        } catch (error) {
            console.error(error);
            alert("An error occured while fetching location data");
            trackException(JSON.stringify(error))
        }
    }

    const fetchAllFobKeyList = async () => {
        if (hasMoreKeys) {
            let config = {
                method: 'get',
                url: `${Base_Url}/api/getKeysPage?page=${fobPageNum}`,
                headers: {}
            };
            axios.request(config)
                .then((response) => {
                    if (response && response.data && response.data.data) {
                        if (fobPageNum == 1) {
                            let fobArr = response.data.data.map(item => ({
                                fob: item.serialNumber,
                                keyCafeId: item.id.toString(),
                                keyCafeName: item.name
                            }));
                            fobArr.splice(0, 0, { "fob": "Add Later", "keyCafeId": "Add Later" });
                            fobPageNum = fobPageNum + 1
                            setfobKeys(fobArr);
                        } else {
                            let fobArr = response.data.data.map(item => ({
                                fob: item.serialNumber,
                                keyCafeId: item.id.toString(),
                                keyCafeName: item.name
                            }));
                            fobPageNum = fobPageNum + 1
                            setfobKeys([...fobKeys, ...fobArr]);
                        }

                        if (response.data.data.length > 0) {
                        } else {
                            sethasMoreKeys(false)
                        }
                    }
                })
                .catch((error) => {
                    sethasMoreKeys(false)
                    console.log(error);
                });
        }
    }

    useEffect(() => {
        if (loading) return;
        if (!user) return navigate("/");
        fetchUserNameAndVehicles();
        fetchAllLocations();
        resetAndFeatchFob()
    }, [user, loading]);

    useEffect(() => {
        if (fobKeys.length > 50) {
            fetchAllFobKeyList()
        }
    }, [fobKeys.length]);

    const resetAndFeatchFob = () => {
        fobPageNum = 1;
        setfobKeys([]);
        sethasMoreKeys(true)
        fetchAllFobKeyList();
    }

    const openDeleteForm = (selectedItem) => {
        setIsDeleteDialogOpen(true);
        setSelectedVehicle(selectedItem);
        // fetchUserNameAndEvents();
    }

    const DeleteVehicle = async () => {
        VehicleDataService.deleteVehicle(selectedVehicle.id);
        setIsDeleteDialogOpen(false);
        fetchUserNameAndVehicles();
    };

    function getPerDayPrice(item) {
        let filterArr = allgroups.filter(t => t.id == item.groupId && item.groupId != "NA")
        if (filterArr && filterArr.length > 0) {
            return filterArr[0]?.pricePerDay
        } else {
            return item?.pricePerDay
        }
    }

    // Debounce the handleSearch function
    const debouncedSearch = debounce(search => {
        const lowerSearch = search.toLowerCase();
        const filtered = allvehicles.filter(event => {
            return (
                event.year.toLowerCase().includes(lowerSearch) ||
                event.model.toLowerCase().includes(lowerSearch) ||
                event.make.toLowerCase().includes(lowerSearch)
            )
        });
        setFilteredVehicles(filtered);
    }, 300); // Adjust the debounce delay as needed

    const handleSearch = event => {
        const value = event.target.value;
        setSearchTerm(value);
        debouncedSearch(value);
    };
    const handleClear = () => {
        setSearchTerm('');
        debouncedSearch('');
    };
    return (
        <Layout>
            <div className={styles.content}>
                <div className={"d-flex justify-space-between top-content"}>
                    <Button icon={<PlusSVG />} className={"primary-btn"} shape="circular" appearance="primary" onClick={() => openFormNew()}>{'New Vehicle'.toUpperCase()}</Button>
                    <CustomSearchInput
                        className={"custom-search-input"}
                        value={searchTerm}
                        onChange={handleSearch}
                        onClick={handleClear}
                    />
                </div>
                <div className={"table-layout"} style={{ border: isMobile ? "none" : undefined }} >
                    <Table aria-label="Table with cell actions">
                        <TableHeader className={"list-row"}>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableHeaderCell key={column.columnKey}>
                                        <span className={"listHeaderText"}>{column.label}</span>
                                    </TableHeaderCell>
                                ))}
                            </TableRow>
                        </TableHeader>
                       <TableBody>
  {filteredVehicles.length > 0 && filteredVehicles.map((item) => {
    const owner = allUsers.find(t => t.id == item.owner) || {};

    return isMobile ? (
      <div key={item.id} className="vehicle-card">
        <div className="vehicle-card-header">
          <div className="vehicle-card-title">{item.year} {item.make} {item.model}</div>
          <div className="vehicle-card-actions">
            <Button
              icon={<EditIcon />}
              className="edit-icon"
              appearance="subtle"
              aria-label="Edit"
              onClick={() => openForm(item)}
            />
            <Button
              icon={<DeleteIcon />}
              className="delete-icon"
              appearance="subtle"
              aria-label="Delete"
              onClick={() => openDeleteForm(item)}
            />
            <Button
              className="btnBorderOnly"
              shape="circular"
              onClick={() => {
                setOpen(true);
                setSelectedVehicle(item);
              }}
            >
              Images
            </Button>
          </div>
        </div>
        <span className="separator"></span>
        <div className="vehicle-card-row">
          <span className="vehicle-card-label">Owner</span>
          <span className="vehicle-card-value">{owner.firstName} {owner.lastName}</span>
        </div>
        <span className="separator"></span>
        <div className="vehicle-card-row">
          <span className="vehicle-card-label">Per Day Price</span>
          <span className="vehicle-card-value">{getPerDayPrice(item)}</span>
        </div>
        <span className="separator"></span>
        <div className="vehicle-card-row">
          <span className="vehicle-card-label">Rental Fleet</span>
          <span className="vehicle-card-value">
            {item.isPartOfWarehouseRentalFleet === true ? <div className="yesBox">Yes</div> : <div className="noBox">No</div>}
          </span>
        </div>
        <span className="separator"></span>
        <div className="vehicle-card-row">
          <span className="vehicle-card-label">Sales Fleet</span>
          <span className="vehicle-card-value">
            {item.isPartOfWarehouseSalesFleet === true ? <div className="yesBox">Yes</div> : <div className="noBox">No</div>}
          </span>
        </div>
      </div>
    ) : (
      <TableRow key={item.id}>
        <TableCell className={"table-row-fonts__primary"}>
          <TableCellLayout>
            {item.year}
          </TableCellLayout>
        </TableCell>
        <TableCell className={"table-row-fonts__desc"}>
          <TableCellLayout>
            <Label title={item.make}>{item.make}</Label>
          </TableCellLayout>
        </TableCell>
        <TableCell className={"table-row-fonts__desc"}>
          <TableCellLayout>
            <Label title={item.model}>{item.model}</Label>
          </TableCellLayout>
        </TableCell>
        <TableCell className={"table-row-fonts__desc"}>
          <TableCellLayout>
            <Label>{owner.firstName} {owner.lastName}</Label>
          </TableCellLayout>
        </TableCell>
        <TableCell className={"table-row-fonts__desc"}>
          <TableCellLayout>
            <Label>{getPerDayPrice(item)}</Label>
          </TableCellLayout>
        </TableCell>
        <TableCell className={"table-row-fonts__desc"}>
          <TableCellLayout>
            {item.isPartOfWarehouseRentalFleet === true ?
              <div className={"yesBox"}>Yes</div> : <div className={"noBox"}>No</div>
            }
          </TableCellLayout>
        </TableCell>
        <TableCell className={"table-row-fonts__desc"}>
          {item.isPartOfWarehouseSalesFleet === true ?
            <div className={"yesBox"}>Yes</div> : <div className={"noBox"}>No</div>
          }
          <TableCellActions>
            <Button
              icon={<EditIcon />}
              appearance="subtle"
              aria-label="Edit"
              onClick={() => openForm(item)}
            />
            <Button
              icon={<DeleteIcon />}
              appearance="subtle"
              aria-label="Delete"
              onClick={() => openDeleteForm(item)}
            />
          </TableCellActions>
        </TableCell>
        <TableCell className={"table-row-fonts__desc"}>
          <Button
            className={"btnBorderOnly"}
            shape="circular"
            onClick={() => {
              setOpen(true);
              setSelectedVehicle(item);
            }}
          >
            Images
          </Button>
        </TableCell>
      </TableRow>
    );
  })}
</TableBody>
                    </Table>
                </div>
            </div>
            <VehicleForm isOpen={isFormOpen} setIsOpen={(val) => setIsFormOpen(val)} selectedVehicle={selectedVehicle}
                updateGrid={fetchUserNameAndVehicles} locations={alllocations} fobKeys={fobKeys} users={allUsers} allgroups={allgroups}></VehicleForm>
            <ImageDialog open={open} setOpen={setOpen} selectedEvent={selectedVehicle && typeof (selectedVehicle) == "object" ? selectedVehicle : null}></ImageDialog>
            <DeleteEventDialog isDeleteDialogOpen={isDeleteDialogOpen}
                setIsDeleteDialogOpen={setIsDeleteDialogOpen} DeleteEvent={DeleteVehicle} text={'Vehicle'} />
        </Layout>
    )
}

export default Vehicles;